<template>
    <div>
        <div class="topimg" style="height: 225px;margin-top: 124px;"></div>
        <div class="layui-container">
            <div class="container" style="width: 1024px; margin: 0 auto;">
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    关于我们</p>
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    多渠道兑换平台网络科技有限公司-T+0实时模式方便快捷，极速分润。 多渠道兑换平台支付安全稳定，连续运营十年，您身边放心的订单计数系统！</p>
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    客服热线</p>
                <!-- <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    有任何问题直接点击下方在线客服联系，我们将第一时间回复您，如遇在线客服未能及时回复您的消息，请拨打7*24小时免费客服热线：QQ:792254439</p>
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    客服QQ</p>
                <div class="col-sm-12" style=" overflow: hidden;    margin-bottom: 30px;">
                    <div class="kefulianxi"
                        style="height: 280px; border: 1px solid #ccc; margin-top: 10px; float: left;width: 16.666%;margin-right: 40px;flex">
                        <div class="kefu1" style="position: relative;">
                            <img src="@/assets/themes/images/yw.png"
                                style="width: 150px; position: relative; left: 50%; top: 20px; margin-left: -75px;">
                            <h4
                                style="text-align: center; margin-top: 30px; font-weight: bold;font-size: 18px;margin-bottom: 0;">
                                客服</h4>
                            <p style="text-align: center; margin-top: 10px;">QQ: 792254439</p>
                            <a href="tencent://AddContact/?fromId=50&fromSubId=1&subcmd=all&uin=792254439"><img
                                    src="@/assets/themes/images/qq.gif"
                                    style="position: relative; left: 50%; top: 10px; margin-left: -75px;"></a>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'contactus',
}
</script>
<style scoped>
.topimg {
    height: 225px;
    background: url('../../assets/themes/images/subbanner.jpg') no-repeat center bottom;
}
</style>